import React from 'react';
import { getCard } from 'Core/components/CreditCardLogos';

const SavedCard = ({ paymentMethod }) => {
  const { img, name } = getCard(paymentMethod.card.brand);

  return (
    <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <div className="flex-shrink-0">
        <img src={img} className="h-8 w-auto" alt={name} />
      </div>
      <div className="flex flex-col">
        <span className="text-xs text-gray-500 font-medium">{name}</span>
        <span className="text-base font-semibold text-gray-900">
          •••• •••• •••• {paymentMethod.card.last4}
        </span>
      </div>
    </div>
  );
};

export default SavedCard;
